
(function () {
  'use strict';

  var _loc = (window.Shopify && window.Shopify.locale || 'de').toLowerCase();
  var _t = _loc.indexOf('it') === 0 ? {
    preorder: 'Prenota ora',
    add: 'Aggiungi al carrello',
    soldOut: 'Esaurito',
    title: 'Preordine',
    delivery: 'Consegna prevista:',
    note: "Nota: Si prega di ordinare i preordini separatamente. La spedizione avverrà solo quando tutti gli articoli saranno disponibili – nessuna consegna parziale."
  } : _loc.indexOf('fr') === 0 ? {
    preorder: 'Précommander',
    add: 'Ajouter au panier',
    soldOut: 'Épuisé',
    title: 'Précommande',
    delivery: 'Livraison prévue :',
    note: "Remarque : Veuillez commander les précommandes séparément. L’expédition n’aura lieu que lorsque tous les articles seront en stock – pas de livraison partielle."
  } : _loc.indexOf('en') === 0 ? {
    preorder: 'Pre-Order now',
    add: 'Add to cart',
    soldOut: 'Sold out',
    title: 'Pre-Order',
    delivery: 'Estimated delivery:',
    note: 'Note: Please order pre-orders separately. Shipping will only occur when all items are in stock – no partial delivery.'
  } : _loc.indexOf('es') === 0 ? {
    preorder: 'Reservar ahora',
    add: 'A\u00f1adir al carrito',
    soldOut: 'Agotado',
    title: 'Preventa',
    delivery: 'Entrega prevista:',
    note: 'Nota: los art\u00edculos en preventa deben pedirse por separado. El env\u00edo se realizar\u00e1 \u00fanicamente cuando todos los art\u00edculos est\u00e9n disponibles \u2013 sin env\u00edos parciales.'
  } : _loc.indexOf('nl') === 0 ? {
    preorder: 'Nu pre-orderen',
    add: 'In winkelwagen leggen',
    soldOut: 'Uitverkocht',
    title: 'Pre-order',
    delivery: 'Verwachte levering:',
    note: 'Let op: pre-orders graag apart bestellen. Verzending vindt pas plaats wanneer alle artikelen op voorraad zijn \u2013 geen deelleveringen.'
  } : {
    preorder: 'Jetzt Vorbestellen',
    add: 'In den Warenkorb legen',
    soldOut: 'Ausverkauft',
    title: 'Vorbestellung',
    delivery: 'Voraussichtliche Lieferung:',
    note: 'Hinweis: Pre-Orders bitte separat bestellen. Versand erfolgt erst, wenn alle Artikel lagernd sind – keine Teillieferung.'
  };
  var TEXT_PREORDER = _t.preorder;
  var TEXT_ADD      = _t.add;
  var TEXT_SOLD_OUT = _t.soldOut;

  var BOX_INNER_HTML = [
    '<div class="al-po-box" style="display:flex;align-items:flex-start;gap:10px;margin-top:12px;margin-bottom:4px;padding:12px 14px;background:#f5f0eb;border-left:3px solid #c8a97e;border-radius:4px;font-size:13px;line-height:1.5;color:#444;">',
      '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#c8a97e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;margin-top:3px;"><path d="M5 12h14M12 5l7 7-7 7"/></svg>',
      '<div class="al-po-text" style="display:flex;flex-direction:column;gap:4px;">',
        '<strong style="font-size:13px;letter-spacing:0.03em;text-transform:uppercase;color:#222;font-weight:700;">' + _t.title + '</strong>',
        '<span class="al-po-date" style="font-size:13px;color:#444;">' + _t.delivery + ' <strong style="color:#222;"></strong></span>',
        '<span style="font-size:12px;color:#666;">' + _t.note + '</span>',
      '</div>',
    '</div>'
  ].join('');


  // AL: Verfügbarkeitszeile mit dem Vorbestell-Status synchronisieren.
  // Das Theme setzt bei "continue" + Bestand 0 die Klasse count-is-unavailable
  // ("Artikel ist nicht verfügbar") - das widerspricht der Vorbestell-Box darunter.
  var _cdWanted = null, _cdObserver = null;
  function syncCountdown(isPreorder) {
    var wrap = document.querySelector('[data-remaining-wrapper]');
    if (!wrap) return;
    _cdWanted = isPreorder ? 'out' : null;
    apply();
    if (!_cdObserver) {
      _cdObserver = new MutationObserver(function () {
        _cdObserver.disconnect(); apply();
        _cdObserver.observe(wrap, { attributes: true, attributeFilter: ['class'] });
      });
      _cdObserver.observe(wrap, { attributes: true, attributeFilter: ['class'] });
    }
    function apply() {
      if (_cdWanted === 'out' && wrap.classList.contains('count-is-unavailable')) {
        wrap.classList.remove('count-is-unavailable');
        wrap.classList.add('count-is-out');
      }
    }
  }

  function initPreorder() {
    var box = document.getElementById('preorder--shipping_info');
    if (!box) return;

    var productDeliveryDate = box.getAttribute('data-delivery') || '';

    var metaEls = document.querySelectorAll('#variant-metafields-json');
    var metaEl  = metaEls[metaEls.length - 1] || null;
    var variantStock    = {};
    var variantDelivery = {};
    if (metaEl) {
      try {
        var data = JSON.parse(metaEl.textContent);
        data.variants.forEach(function (v) {
          variantStock[v.id] = v.stock;
          if (v.metafields && v.metafields.custom && v.metafields.custom.shipping_info) {
            variantDelivery[v.id] = v.metafields.custom.shipping_info;
          }
        });
      } catch (e) {}
    }

    var hasPreorderData = productDeliveryDate || Object.keys(variantDelivery).length > 0;
    if (!hasPreorderData) return;

    var currentVariantId = null;
    var currentAvailable = true;

    function getDeliveryDate(variantId) {
      return productDeliveryDate || variantDelivery[variantId] || '';
    }

    // MutationObserver: disconnect before our own changes, reconnect after
    var observer = new MutationObserver(function () {
      observer.disconnect();
      renderBox();
      observer.observe(box, { childList: true });
    });
    observer.observe(box, { childList: true });

    function renderBox() {
      var sectionId    = box.getAttribute('data-section-id') || '';
      var propEl       = document.getElementById('al-preorder-prop-' + sectionId);
      var stock        = variantStock[currentVariantId];
      var delivery     = getDeliveryDate(currentVariantId);
      var isPreorder   = !!delivery && currentAvailable && (stock !== undefined ? stock <= 0 : true);

      syncCountdown(isPreorder);

      if (isPreorder) {
        if (!box.querySelector('.al-po-box')) {
          box.innerHTML = BOX_INNER_HTML;
        }
        var dateEl = box.querySelector('.al-po-date');
        if (dateEl) dateEl.innerHTML = _t.delivery + ' <strong style="color:#222;">' + delivery + '</strong>';
        box.removeAttribute('hidden');
        if (propEl) { propEl.value = delivery; propEl.disabled = false; }
      } else {
        box.setAttribute('hidden', '');
        if (propEl) { propEl.value = ''; propEl.disabled = true; }
      }

      document.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
        var textEl = btn.querySelector('[data-add-to-cart-text]');
        if (!textEl) return;
        var setFirstText = function (el, text) {
          for (var i = 0; i < el.childNodes.length; i++) {
            if (el.childNodes[i].nodeType === 3) { el.childNodes[i].textContent = text; return; }
          }
          el.insertBefore(document.createTextNode(text), el.firstChild);
        };
        if (isPreorder) {
          setFirstText(textEl, TEXT_PREORDER);
          btn.classList.add('btn--preorder');
        } else if (!currentAvailable) {
          setFirstText(textEl, TEXT_SOLD_OUT);
          btn.classList.remove('btn--preorder');
        } else {
          setFirstText(textEl, TEXT_ADD);
          btn.classList.remove('btn--preorder');
        }
      });
    }

    function getInitialVariantId() {
      var urlParams = new URLSearchParams(window.location.search);
      var variantParam = urlParams.get('variant');
      if (variantParam) return parseInt(variantParam, 10);
      var input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (input && input.value) return parseInt(input.value, 10);
      var ids = Object.keys(variantStock);
      return ids.length ? parseInt(ids[0], 10) : null;
    }

    var initialId = getInitialVariantId();
    if (initialId) {
      currentVariantId = initialId;
      currentAvailable = variantStock[initialId] > 0 || !!getDeliveryDate(initialId);
      renderBox();
    }

    document.addEventListener('theme:variant:change', function (e) {
      if (e.detail && e.detail.variant) {
        currentVariantId = e.detail.variant.id;
        currentAvailable = e.detail.variant.available;
        renderBox();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPreorder);
  } else {
    initPreorder();
  }
})();
